import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import moment from 'moment'
import Link from 'components/shared/Link'
import BookingStateIcon from 'components/shared/BookingStateIcon'
import getBookingReminders from 'lib/getBookingReminders'
import ExpressDelivery from 'assets/icons/express-delivery.svg'
import { bookingHasPremiumService } from 'lib/bookingStateHelper'
import BookingListItemProducts from '../BookingListItemProducts'

import './index.css'

const Meta = ({booking}) => {
  if (booking.state === 'booked') {
    const startsAt = moment(booking.startsAt)
    const endsAt = moment(booking.endsAt)

    return (
      <div className="meta">
        <span className="day">{startsAt.format('DD. MMM')}</span>
        <span className="time">kl. {startsAt.format('HH:mm')}</span>
        <span className="time">- {endsAt.format('HH:mm')}</span>
      </div>
    )
  }

  return (
    <div className="meta">
      <BookingStateIcon state={booking.state} />
    </div>
  )
}

const BookingsListItem = ({booking}) => {
  const reminders = getBookingReminders(booking)
  const isPremium = bookingHasPremiumService(booking)

  return (
    <div className={`booking-list-item ${booking.state} ${isPremium ? 'premium' : ''}`}>
      <Meta booking={booking} />

      <div className="description">
        <div className="address-icons">
          <div className="address">
            <Link to={`/bookings/${booking.id}`}>
              {booking.estate.streetAddress}{', '}
              {booking.estate.postalCode} {booking.estate.postalArea}
            </Link>
          </div>
          <div className="icons">
            {reminders.map(r => (
              <img key={r.type} src={r.icon} alt={r.text} width="16" height="16" />
            ))}
            {booking.expressDelivery &&
              <img src={ExpressDelivery} alt="" width="16" height="16" />
            }
          </div>
        </div>

        <BookingListItemProducts booking={booking} />
      </div>
    </div>
  )
}

BookingsListItem.propTypes = {
  booking: PropTypes.object.isRequired,
}

BookingsListItem.fragments = {
  booking: gql`
    fragment BookingsListItem on Booking {
      id
      state
      resourceName
      startsAt
      endsAt
      pickUpKeysInstructions
      expressDelivery
      premiumService
      estate {
        id
        streetAddress
        postalArea
        postalCode
        location {
          lat
          lng:lon
        }
        products {
          edges {
            node {
              id
              state
            }
          }
        }
      }
      products {
        edges {
          node {
            id
            name
            ... on MeasurementProduct {
              usedAsInputFor { id }
            }
          }
        }
      }
    }
  `,
}

export default BookingsListItem
